import { Card } from '@solinkcorp/solink-ui/components/Card';
import { cn } from '@solinkcorp/solink-ui/lib/utils';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { CARD_MAX_WIDTH_CLASS, STEP_CARD_MIN_HEIGHT_CLASS } from './constants';

interface LoadingCardProps {
  message: string;
  'data-testid'?: string;
}

// Shared shell for in-flight steps (location lookup, verifying) — same card footprint as the other steps.
const LoadingCard: React.FC<LoadingCardProps> = ({ message, ...rest }) => (
  <Card
    role="status"
    className={cn(
      CARD_MAX_WIDTH_CLASS,
      STEP_CARD_MIN_HEIGHT_CLASS,
      'flex-row items-center gap-2 text-foreground-secondary',
    )}
    {...rest}
  >
    <Loader2 className="size-6 animate-spin" aria-hidden="true" />
    <span className="body-md">{message}</span>
  </Card>
);

export default LoadingCard;
